export default (conf) => {
	return window?.LEXUS?.config?.[conf] || process?.env?.[conf];
};
